import React, { useState } from 'react';
import '../../../App.css'; // Add this if you want to use custom CSS

const Hservice = () => {
  const [activeModal, setActiveModal] = useState(null); // null | 1 | 2 | 3

  const openModal = (id) => {
    setActiveModal(id);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      <div className="rs-services rs-services-style1 mt-60" style={{marginTop: "3%"}}>
        <div className="container">
          <div className="row">
            {/* Student */}
            <div className="col-lg-3 col-md-6">
              <div className="services-item blue-color rs-animation-hover">
                <div className="services-icon">
                  <i className="fa fa-american-sign-language-interpreting rs-animation-scale-up" />
                </div>
                <div className="services-desc">
                  <h4 className="services-title">Student</h4>
                  <p>
                    Top Faculty is an online platform that connects students with India’s best tutors for personalized learning.
                  </p>
                  <button className="btn btn-warning" onClick={() => openModal(1)}>Read More</button>
                </div>
              </div>
            </div>

            {/* Teacher */}
            <div className="col-lg-3 col-md-6">
              <div className="services-item orange-color rs-animation-hover">
                <div className="services-icon">
                  <i className="fa fa-book rs-animation-scale-up" />
                </div>
                <div className="services-desc">
                  <h4 className="services-title">Teacher</h4>
                  <p>
                    Top Faculty is a powerful platform for educators to reach students across India and share their expertise.
                  </p>
                  <button className="btn btn-warning" onClick={() => openModal(2)}>Read More</button>
                </div>
              </div>
            </div>

            {/* Coaching Center */}
            <div className="col-lg-3 col-md-6">
              <div className="services-item purple-color rs-animation-hover">
                <div className="services-icon">
                  <i className="fa fa-graduation-cap rs-animation-scale-up" />
                </div>
                <div className="services-desc">
                  <h4 className="services-title">Coaching Center</h4>
                  <p>
                    Top Faculty is the perfect platform for coaching institutes to expand their reach and connect with students.
                  </p>
                  <button className="btn btn-warning" onClick={() => openModal(3)}>Read More</button>
                </div>
              </div>
            </div>

            {/* Facilities */}
            <div className="col-lg-3 col-md-6">
              <div className="services-item red-color rs-animation-hover">
                <div className="services-icon">
                  <i className="fa fa-user rs-animation-scale-up" />
                </div>
                <div className="services-desc">
                  <h4 className="services-title">Facilities</h4>
                  <p>
                    We offer online classes for students in school & college. And Just choose your course & take a free trial class.
                  </p>
                  <button className="btn btn-warning" onClick={() => openModal(4)}>Read More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= Modal Area ================= */}

      {activeModal && (
        <div className="modal-overlay">
          
          <div className="modal-box">
          <i onClick={closeModal} class="fa fa-times" style={{ display: "flex",    cursor: "pointer",fontSize: "20px",color: "red"}} aria-hidden="true"></i>

          <div className='modalinner'>
             <h3>
              {activeModal === 1 && "Student Read"}
              {activeModal === 2 && "Teacher Read"}
              {activeModal === 3 && "Coaching Center Read"}
              {activeModal === 4 && "Facilities Read"}
            </h3>
            
            <p>
              {activeModal === 1 && "टॉप फैकल्टी एक ऑनलाइन प्लेटफॉर्म है जहां छात्र भारत के बेहतरीन शिक्षकों से जुड़ सकते हैं और अपनी सुविधा के अनुसार सीख सकते हैं। चाहे आपको पूरा कोर्स पढ़ना हो या कोई विशेष टॉपिक समझना हो, हमारे अनुभवी ट्यूटर आपको घर बैठे  बेहतरीन शिक्षा प्रदान करते हैं। फ्लेक्सिबल शेड्यूल और इंटरएक्टिव सेशंस के साथ, यह प्लेटफॉर्म परीक्षा की तैयारी, स्किल डेवलपमेंट और अकादमिक सुधार के लिए एक आदर्श समाधान है। हमारे विशेषज्ञ विभिन्न विषयों में माहिर हैं, जिससे आपको सर्वोत्तम मार्गदर्शन मिलता है। टॉप फैकल्टी के साथ सीखना अब और भी आसान, सुलभ और प्रभावी हो गया है। आज ही जुड़ें और भारत के श्रेष्ठ शिक्षकों से सीखने का लाभ उठाएं!"}
              {activeModal === 2 && "टॉप फैकल्टी शिक्षकों के लिए एक बेहतरीन प्लेटफॉर्म है, जहां वे पूरे भारत के छात्रों तक अपनी विशेषज्ञता पहुंचा सकते हैं। एक ट्यूटर के रूप में, आप पूरा कोर्स या कोई विशेष विषय घर बैठे पढ़ा सकते हैं। हम आपको एक आसान और प्रभावी ऑनलाइन शिक्षण अनुभव प्रदान करते हैं, जिसमें फ्लेक्सिबल शेड्यूल और सीखने के इच्छुक छात्रों की बड़ी संख्या शामिल है। चाहे आप अकादमिक विषयों, प्रतियोगी परीक्षाओं या कौशल आधारित पाठ्यक्रमों में विशेषज्ञ हों, टॉप फैकल्टी आपको सही छात्रों से जोड़ता है। अपनी फीस खुद तय करें, कक्षाओं को कुशलतापूर्वक प्रबंधित करें और भारत के सर्वश्रेष्ठ शिक्षकों में अपना नाम बनाएं। आज ही जुड़ें और देशभर के छात्रों का भविष्य संवारें!"}
              {activeModal === 3 && "टॉप फैकल्टी कोचिंग संस्थानों के लिए एक आदर्श प्लेटफॉर्म है, जहां वे देशभर के अनुभवी शिक्षकों और उत्साही छात्रों से जुड़ सकते हैं। यदि आप एक अकादमिक कोचिंग सेंटर, प्रतियोगी परीक्षा संस्थान या कौशल विकास प्रशिक्षण अकादमी चलाते हैं, तो हमारा प्लेटफॉर्म आपके पाठ्यक्रमों को ऑनलाइन लाने में मदद करता है। यहां आप बेहतरीन शिक्षकों की भर्ती कर सकते हैं, संगठित लर्निंग प्रोग्राम प्रदान कर सकते हैं और पूरे भारत से छात्रों को आकर्षित कर सकते हैं। टॉप फैकल्टी के माध्यम से आपको फ्लेक्सिबल शेड्यूल, सुगम ऑनलाइन शिक्षण उपकरण और विशाल छात्र नेटवर्क मिलता है, जिससे आपका संस्थान डिजिटल रूप से आगे बढ़ सकता है। आज ही जुड़ें और अपने कोचिंग संस्थान को नई ऊंचाइयों पर ले जाएं!"}
              {activeModal === 4 && "Our facilities include trial classes, student performance tracking, and smart class features."}
            </p>
           
            <button className="btn btn-danger" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hservice;
